function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 2.91465C12.0826 2.70873 12.5 2.15311 12.5 1.5C12.5 0.671573 11.8284 0 11 0C10.1716 0 9.5 0.671573 9.5 1.5C9.5 2.15311 9.9174 2.70873 10.5 2.91465V4H5.5C3.84315 4 2.5 5.34315 2.5 7C1.39543 7 0.5 7.89543 0.5 9V12C0.5 13.1046 1.39543 14 2.5 14V21.5L7.5 19H16.5C18.1569 19 19.5 17.6569 19.5 16V14C20.6046 14 21.5 13.1046 21.5 12V9C21.5 7.89543 20.6046 7 19.5 7C19.5 5.34315 18.1569 4 16.5 4H11.5V2.91465ZM7 11C8.10457 11 9 10.1046 9 9C9 7.89543 8.10457 7 7 7C5.89543 7 5 7.89543 5 9C5 10.1046 5.89543 11 7 11ZM17 9C17 10.1046 16.1046 11 15 11C13.8954 11 13 10.1046 13 9C13 7.89543 13.8954 7 15 7C16.1046 7 17 7.89543 17 9ZM7.75 15C7.33579 15 7 15.3358 7 15.75C7 16.1642 7.33579 16.5 7.75 16.5H14.25C14.6642 16.5 15 16.1642 15 15.75C15 15.3358 14.6642 15 14.25 15H7.75Z",
  fill: "#637280"
});
function SvgChatbot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot);
export default __webpack_public_path__ + "static/media/chatbot.816aaa08.svg";
export { ForwardRef as ReactComponent };